module.exports = __webpack_public_path__ + "img/pre-banner-centre.1ad25b76.svg";